module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/sections/competitor_comparison/assets/arrow-4f7b233b11ac5032803219a81a595a26.png";